import React from 'react';
import { useAppState } from "../../application/AppState";
import { setSelectedClaim } from "../../application/actions";
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import useTranslation from "../../application/translation";

function getLastSignDate(language) {
    const nd = new Date();
    nd.setDate(nd.getDate() + 9);
    const d = new Date(nd);
    const month = (`0${d.getMonth() + 1}`).slice(-2);
    const day = (`0${d.getDate()}`).slice(-2);
    const year = d.getFullYear();
    return language === "no" ? `${day}-${month}-${year}` : `${year}-${month}-${day}`;
}

function insertDateInText(text, date) {
    return text.replace("#lastsigndate#", date);
}

function insertRefInText(text, ref) {
    return text.replace("#refnr#", ref);
}

function getRefNumber(refInt) {
    const d = new Date();
    const month = (`0${d.getMonth() + 1}`).slice(-2);
    const day = (`0${d.getDate()}`).slice(-2);
    const year = d.getFullYear().toString().slice(-2);
    return `SK-${year}-${month}-${day}-${refInt}`;
}

export default function ApplicationConfirmation({ refNr }) {
    const [{ language }, dispatch] = useAppState();
    const translation = useTranslation();

    const resetSelectedClaim = () => {
        dispatch(setSelectedClaim(null));
    };

    if (refNr === -1) {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {translation.application_confirmation1}
                    </Typography>
                    <Typography variant="body2">{translation.application_confirmation2}</Typography>
                    <Typography variant="body2">{translation.application_confirmation3}</Typography>
                    <Typography variant="body2">{translation.application_confirmation4}</Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={resetSelectedClaim}
                        aria-label={translation.application_confirmation_back}
                    >
                        {translation.application_confirmation_back}
                    </Button>
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography variant="h6" color="error">
                    <strong>{translation.confirmation_header1}</strong>
                </Typography>
                <Typography variant="body2">
                    {insertRefInText(translation.confirmation_text0, getRefNumber(refNr))}
                </Typography>
                <br />
                <Typography variant="body2">{translation.confirmation_text1}</Typography>
                <br />
                <Typography variant="body2">{translation.confirmation_text2}</Typography>
                <Typography variant="body2">
                    {insertDateInText(translation.confirmation_text3, getLastSignDate(language))}
                </Typography>
                <Typography variant="body2">{translation.confirmation_text4}</Typography>
                <Typography variant="body2">{translation.confirmation_text5}</Typography>
                <br />
                <br />
                <Button
                    variant="contained"
                    color="primary"
                    onClick={resetSelectedClaim}
                    aria-label={translation.button_backtomain}
                >
                    {translation.button_backtomain}
                </Button>
            </Grid>
        </Grid>
    );
}
